import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CloseIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 25 25" htmlColor={Color.Headings} {...props}>
      <path d="m12.034 13.779-5.073 5.073a.72.72 0 0 1-.522.213.7.7 0 0 1-.532-.213.72.72 0 0 1-.217-.527q0-.31.217-.527l5.073-5.073-5.073-5.073a.73.73 0 0 1-.212-.522.7.7 0 0 1 .212-.532.72.72 0 0 1 .527-.217q.31 0 .527.217l5.073 5.073 5.073-5.073a.72.72 0 0 1 .522-.212.7.7 0 0 1 .532.212q.217.217.217.527a.72.72 0 0 1-.217.527l-5.073 5.073 5.073 5.073q.208.208.213.522a.7.7 0 0 1-.213.532.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217z" />
    </MuiSvgIcon>
  );
}
export default CloseIcon;
